/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/lookup_offices-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/lookup_offices-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/lookup_offices-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-lookup_offices-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/lookup_offices.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/lookup_offices-entity-config.ts
 * Public fields: 7/7 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const LookupOfficesSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  code: Type.String(), // code field
  name: Type.String(), // name field
  sort_order: Type.Number(), // sort_order field
  archived: Type.Boolean(), // archived field
  created_at: Type.String({ format: "date-time" }), // created_at field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
});

export const CreateLookupOfficesSchema = Type.Object({
  code: Type.String(), // code field
  name: Type.String(), // name field
  sort_order: Type.Optional(Type.Number()), // sort_order field
  archived: Type.Optional(Type.Boolean()), // archived field
});

export const UpdateLookupOfficesSchema = Type.Object({
  code: Type.Optional(Type.String()), // code field
  name: Type.Optional(Type.String()), // name field
  sort_order: Type.Optional(Type.Number()), // sort_order field
  archived: Type.Optional(Type.Boolean()), // archived field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type LookupOfficesRow = Static<typeof LookupOfficesSchema>;
export type LookupOfficesInsert = Static<typeof CreateLookupOfficesSchema>;
export type LookupOfficesUpdate = Static<typeof UpdateLookupOfficesSchema>;

// Legacy type aliases for backward compatibility
export type LookupOffices = LookupOfficesRow;
export type CreateLookupOffices = LookupOfficesInsert;
export type UpdateLookupOffices = Static<typeof UpdateLookupOfficesSchema>;

// Field configuration metadata
export const LookupOfficesFieldConfig = {
  filterable: ['id', 'code'] as const,
  sortable: ['sort_order', 'created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'code', 'name', 'sort_order', 'archived', 'updated_at'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface LookupOfficesQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface LookupOfficesResponse {
  data: LookupOffices[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleLookupOfficesResponse {
  data: LookupOffices | null;
  error: Error | null;
}
